import React, { Fragment } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFlip } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-flip";
import "swiper/css/autoplay";
import LazyLoadingImg from "./LazyLoadingImg";

export default function FlipCard({ imgArray, dir = "ltr" }) {
  return (
    <Fragment>
      <Swiper
        dir={dir}
        effect={"flip"}
        modules={[Autoplay, EffectFlip]}
        className="flipCard"
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        speed={1500}
      >
        {imgArray.map((imgObj, idx) => (
          <SwiperSlide key={idx}>
            <LazyLoadingImg
              src={imgObj}
              alt="CTA Background"
              title="CTA Background"
              className=""
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Fragment>
  );
}
